module.exports = __webpack_public_path__ + "static/media/combat(4).d26936c3.PNG";